import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Header from "./header/Header";
import Nav from "./nav/Nav";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { UserAuthStatus } from "consts";
import { getCustomerAuthStatus } from "redux/CustomerSlice/selector";
import { checkAuthCustomerAction } from "redux/CustomerSlice/asyncActions";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function CustomerLayout() {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const authStatus = useAppSelector(getCustomerAuthStatus);

  dispatch(checkAuthCustomerAction());

  if (authStatus === UserAuthStatus.Unauthorized) {
    return <Navigate to="/signin" />;
  }

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />

      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
